module.exports = __webpack_public_path__ + "static/media/search-mechiron.62d0f685.svg";